import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function OfferSection() {
  return <section id="offer-section" className="w-full bg-white py-20 px-6 border-t-4 border-gold" data-id="element-103">
      <div className="max-w-3xl mx-auto text-center" data-id="element-104">
        <FadeIn data-id="element-105">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-106">
            Recupera el activo más importante que tienes:
            <br className="hidden md:block" data-id="element-107" />
            <span className="text-sage" data-id="element-108">
              Tu capacidad de pensar con claridad.
            </span>
          </h2>

          <p className="text-xl text-charcoal mb-10" data-id="element-109">
            No permitas que la transición biológica te quite tu voz.
          </p>

          <div className="bg-cream p-8 md:p-12 rounded-2xl border-2 border-gold/30 mb-10 max-w-xl mx-auto shadow-xl" data-id="element-110">
            <p className="text-sm font-bold text-charcoal-light uppercase tracking-widest mb-2" data-id="element-111">
              Inversión Única
            </p>
            <div className="inline-block bg-red-500 text-white text-sm font-bold px-3 py-1 rounded-full mb-4" data-id="element-112">
              -68% DESCUENTO
            </div>
            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-113">
              <span className="text-2xl md:text-3xl text-charcoal-light/50 line-through font-serif" data-id="element-114">
                $19.99
              </span>
              <div className="text-5xl md:text-6xl font-bold text-sage" data-id="element-115">
                $6.39{' '}
                <span className="text-2xl text-charcoal-light font-normal" data-id="element-116">
                  USD
                </span>
              </div>
            </div>

            <Button className="w-full py-5 text-xl" data-id="element-117">
              ¡SÍ, QUIERO RECUPERAR MI CLARIDAD MENTAL HOY MISMO!
            </Button>

            <div className="mt-6 flex flex-col items-center gap-2 text-sm text-charcoal-light" data-id="element-118">
              <div className="flex items-center gap-2" data-id="element-119">
                <svg className="w-5 h-5 text-sage" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-120">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-121" />
                </svg>
                <span data-id="element-122">Pago 100% seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-123">
                <svg className="w-5 h-5 text-sage" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-124">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" data-id="element-125" />
                </svg>
                <span data-id="element-126">Acceso instantáneo al protocolo digital</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}